import ApiRequest from "../utils/ApiRequest";
import { bulkUploadModel } from "../utils/bulkUploadModel";

export default class Category {
  static getAll = async () => {
    return await ApiRequest.set("v1/categories/getallcategory", "GET");
  }

  static getById = async (id) => {
    return await ApiRequest.set(`v1/categories/getbyid/${id}`, "GET");
  }

  static create = async (body) => {
    return await ApiRequest.set(`v1/categories/create`, "POST", body);
  }

  static edit = async (id, body) => {
    return await ApiRequest.set(`v1/categories/update/${id}`, "PUT", body);
  }

  static delete = async (id) => {
    return await ApiRequest.set(`v1/categories/delete/${id}`, "DELETE");
  }

  static bulkUpload = async (file, dryRun = false) => {
    return await bulkUploadModel('v1/categories/').bulkUpload(file, dryRun);
  };

  static downloadTemplate = async () => {
    return await bulkUploadModel('v1/categories/').downloadTemplate();
  };
}